




































// vendor
import { defineComponent, computed, ref, ComputedRef, inject, PropType } from "@vue/composition-api";
import { format as formatDate } from "date-fns";
// project
// import { EditText, IEditTextModal } from "@/components.generic/utility-modal";
import { Study } from "@/psychlab/types";
import * as StudyAPI from "@/services/api/studies";
import * as AppModal from "@/AppModal";
// local
import { StudyContext } from "../StudyContext";

export default defineComponent({

	emits:[],
	props:{
		study:{
			type:Object as PropType<Study>,
			required:true,
		}
	},
	setup(props){
		
		// const editTextModal = ref<IEditTextModal>();

		// const studyContext = inject<ComputedRef<StudyContext>>("studyContext");

		// if(!studyContext){ throw Error("Study Title: Study context missing!"); }

		// const {
		// 	study,
		// } = studyContext.value;

		const studyName = computed(() => {
			return props.study.name;
		});

		const dateLabel = computed(() => {
			return formatDate(new Date(props.study.created), "EEEE MMMM dd, y @ HH:mm");
		});

		const editName = () => {


			AppModal.editText({
				title:"Rename Study",
				value:props.study.name,
				validator(v:string){
					return v.length > 1 && v !== props.study.name;
				}
			}, async (nv) => {
				try {
					await StudyAPI.setStudyName(props.study._id, nv);
					props.study.name = nv;
				} catch (err) {
					console.log(err.message);
				}
			});

		};

		const openContext = (e:Event) => {
			AppModal.context(e, [
				{
					name:"Rename",
					icon:"mdi.pencil-box",
					fn:editName,
				}
			]);
		};

		return {
			studyName,
			// editName,
			// editTextModal,
			dateLabel,
			openContext,
		};
	}
});

